import { useSelector } from 'react-redux';

const Dashboard = () => {
    const { userInfo, isInTeams, accessToken, tokenError } = useSelector(state => state.user);
    

    return (
        <div>
            <div className="teams-card">
                <h3>Welcome to Teams App</h3>
                <p>Status: <span className="status-online">
                    {isInTeams ? '✅ Connected to Teams' : '🔧 Development Mode'}
                </span></p>
                <p>User: {userInfo?.displayName || 'Loading...'}</p>
                <p>Email: {userInfo?.userPrincipalName || 'Not available'}</p>
                <button className="teams-button">Get Started</button>
                <button className="teams-button-secondary" style={{ marginLeft: '8px' }}>Learn More</button>
            </div>


            <div className="teams-card">
                <h3>Access Token</h3>
                {tokenError && (
                    <div style={{
                        marginTop: '15px',
                        padding: '10px',
                        color: '#721c24',
                        borderRadius: '4px',
                        border: '1px solid #f5c6cb'
                    }}>
                        ⚠️ {tokenError}
                    </div>
                )}

                {accessToken ? (
                    <div style={{ marginTop: '15px' }}>
                        <div style={{
                            padding: '15px',
                            borderRadius: '4px',
                            wordBreak: 'break-all',
                            fontFamily: 'Courier New, monospace',
                            fontSize: '12px',
                            maxHeight: '200px',
                            overflow: 'auto'
                        }}>
                            {accessToken}
                        </div>
                    </div>
                ) : !tokenError && (
                    <div style={{ marginTop: '15px', color: '#605e5c' }}>Loading token...</div>
                )}
            </div>

            <div className="teams-card">
                <h3>Quick Actions</h3>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <button className="teams-button">Create Report</button>
                    <button className="teams-button">View Analytics</button>
                    <button className="teams-button">Export Data</button>
                </div>
            </div>

            <div className="teams-card">
                <h3>Recent Activity</h3>
                <p style={{ color: '#605e5c' }}>No recent activity to display.</p>
            </div>

          
        </div>
    );
};

export default Dashboard;
